/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Transcript_Export_Preset_LoadedInputs */

const en_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" loaded`)
};

const fr_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prereglage "${i?.name}" charge`)
};

const de_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" geladen`)
};

const it_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" caricata`)
};

const ru_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загружен пресет "${i?.name}".`)
};

const es_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preajuste "${i?.name}" cargado`)
};

const zh_cn2_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预设“${i?.name}”已加载`)
};

const ja_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」がロードされました`)
};

const hi_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" लोड हो गया`)
};

const pt_pt2_transcript_export_preset_loaded = /** @type {(inputs: Transcript_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" carregada`)
};

/**
* | output |
* | --- |
* | "Preset \"{name}\" loaded" |
*
* @param {Transcript_Export_Preset_LoadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_loaded = /** @type {((inputs: Transcript_Export_Preset_LoadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_LoadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_loaded(inputs)
	if (locale === "de") return de_transcript_export_preset_loaded(inputs)
	if (locale === "it") return it_transcript_export_preset_loaded(inputs)
	if (locale === "ru") return ru_transcript_export_preset_loaded(inputs)
	if (locale === "es") return es_transcript_export_preset_loaded(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_loaded(inputs)
	if (locale === "ja") return ja_transcript_export_preset_loaded(inputs)
	if (locale === "hi") return hi_transcript_export_preset_loaded(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_loaded(inputs)
	return en_transcript_export_preset_loaded(inputs)
});